import React from "react";
import FormItem from "../../../molecules/FormItem/FormItem";
import { Form, Formik } from "formik";
import { initialValues } from "./initialValues";
import {
  areas,
  customers,
  specialisations,
  types,
  willStocks,
} from "./selects";
import { validationSchema } from "./validationSchema";
import styled from "styled-components";
import { PRIMARY } from "../../../../vars/vars";
import Checkbox from "../../../atoms/Checkbox/Checkbox";
import { Link } from "react-router-dom";
import UniversalModal from "../../UniversalModal/UniversalModal";
import ReCAPTCHA from "react-google-recaptcha";
import useContactForm from "../../../../hooks/useContactForm";
import { countries } from "../../../../vars/countries";

const DistributorForm = () => {
  const recaptchaDealerRef = React.useRef(null);

  const { onSubmit, showModal, modalText, setShowModal } = useContactForm(
    "DEALER",
    recaptchaDealerRef
  );

  const props = {
    onSubmit,
    initialValues,
    validationSchema,
  };
  return (
    <section>
      <Formik {...props}>
        {(props) => (
          <Form>
            <FormItem label={"Imię"} required name={"firstName"} />
            <FormItem label={"Nazwisko"} required name={"lastName"} />
            <FormItem label={"Nazwa firmy"} required name={"company"} />
            <FormItem label={"Email"} required name={"email"} type={"email"} />
            <FormItem label={"Telefon"} name={"phone"} type={"phone"} />
            <FormItem label={"Numer NIP"} required name={"vat"} />
            <Interlude>Adres do faktury</Interlude>
            <FormItem
              label={"Ulica i numer"}
              required
              name={"billingAddress1"}
            />
            <FormItem
              label={"Ciąg dalszy adresu (opcjonalnie)"}
              name={"billingAddress2"}
            />
            <FormItem label={"Miasto"} required name={"billingAddressCity"} />
            <FormItem
              label={"Kod pocztowy"}
              required
              name={"billingAddressZip"}
            />
            <FormItem
              required
              selectLabel={"Państwo"}
              name={"billingAddressCountry"}
              label={"Państwo"}
              select
              items={countries}
            />
            <div className={"mt-2"}>
              <Checkbox name={"isDeliveryDifferent"}>
                Adres korespondencyjny (jeśli inny niż powyżej)
              </Checkbox>
            </div>
            {props.values.isDeliveryDifferent && (
              <>
                <Interlude>Adres korespondencyjny</Interlude>
                <FormItem
                  label={"Ulica i numer"}
                  required
                  name={"deliveryAddress1"}
                />
                <FormItem
                  label={"Ciąg dalszy adresu (opcjonalnie)"}
                  name={"deliveryAddress2"}
                />
                <FormItem
                  label={"Miasto"}
                  required
                  name={"deliveryAddressCity"}
                />
                <FormItem
                  label={"Kod pocztowy"}
                  required
                  name={"deliveryAddressZip"}
                />
                <FormItem
                  required
                  selectLabel={"Państwo"}
                  name={"deliveryAddressCountry"}
                  label={"Państwo"}
                  select
                  items={countries}
                />
              </>
            )}
            <FormItem
              label={"Treść wiadomości"}
              textarea
              required
              name={"message"}
            />
            <Interlude>
              Odpowiadając na poniższe dodatkowe pytania, możesz pomóc nam w
              dostarczeniu Tobie naszych usług optymalnie dopasowanych szybciej
              oraz precyzyjniej.
            </Interlude>
            <FormItem
              select
              label={
                "Czy jesteś hurtownikiem/sprzedawcą detalicznym/warsztatem/inny?"
              }
              name={"type"}
              items={types}
            />
            <FormItem
              select
              label={
                "Jesteś klientem indywidualnym czy warsztatem lub sprzedawcą detalicznym?"
              }
              name={"customer"}
              items={customers}
            />
            <FormItem
              label={
                "Czy masz sklep on-line (jeśli tak podaj proszę jego adres www)?"
              }
              name={"www"}
            />
            <FormItem
              select
              label={
                "Czy masz specjalizacę (wybrane marki pojazdów lub części)?"
              }
              name={"specialisation"}
              items={specialisations}
            />
            <FormItem
              label={"Dodatkowy komentarz"}
              name={"specialisationOther"}
            />
            <FormItem
              select
              label={
                "Świadczysz usługi lokalnie/masz zasięg krajowy/jesteś eksporterem?"
              }
              name={"area"}
              items={areas}
            />
            <FormItem
              select
              label={"Czy planujesz posiadać stany magazynowe w swojej firmie?"}
              name={"willStock"}
              items={willStocks}
            />
            <Checkbox name={"privacyDealer"}>
              Akceptuję{" "}
              <StyledLink to={"/privacy"}>Politykę prywatności</StyledLink>
            </Checkbox>
            {showModal && (
              <UniversalModal
                text={modalText}
                clickHandler={() => setShowModal(false)}
              />
            )}
            <ReCAPTCHA
              ref={recaptchaDealerRef}
              size="invisible"
              sitekey="6LenKrEUAAAAAE1bjyJeZ563lCnEG29Y0sEyBhp3"
            />
            <StyledButton type={"submit"}>Wyślij</StyledButton>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default DistributorForm;

const Interlude = styled.p`
  margin-top: 20px;
`;

const StyledButton = styled.button`
  margin: 20px 0;
  display: block;
  padding: 10px 20px;
  background: #292b29;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.1s ease;
  white-space: nowrap;

  &:hover {
    background-color: ${PRIMARY};
  }
`;

const StyledLink = styled(Link)`
  font-weight: 600;

  &:hover {
    color: ${PRIMARY};
    cursor: pointer;
  }
`;
